import { useRecordContext } from 'react-admin';

import PendingPolicyChangeDetail from '../pending-policy-change-detail';
import PolicyExpandableDatagrid from '../policy-expandable-datagrid';

function parseToPolicyChanges(record) {
  if (!record) {
    return [];
  }

  return record.changes_history.map(item => {
    const changes = item.changes ? JSON.parse(item.changes) : null;
    return {
      args: JSON.parse(item.args),
      id: item?.id,
      change_type: item?.change_type,
      multiple_pet_discount_percentage: record?.multiple_pet_discount_percentage,
      group_discount_percentage: record?.group_discount_percentage,
      status: item.processed_at ? 'updated' : 'pending',
      processed_at: item?.processed_at,
      diff: changes,
    };
  });
}

function PolicyDatagridExpand() {
  const record = useRecordContext();
  const changes = parseToPolicyChanges(record);

  const { pendingPolicyChanges, processedPolicyChanges } = changes.reduce(
    (acc, change) => {
      if (change.status === 'pending') {
        acc.pendingPolicyChanges.push(change);
      } else {
        acc.processedPolicyChanges.push(change);
      }
      return acc;
    },
    { pendingPolicyChanges: [], processedPolicyChanges: [] }
  );

  const pendingPolicyChangesDetails = pendingPolicyChanges.map(
    pendingPolicyChange => (
      <PendingPolicyChangeDetail
        key={pendingPolicyChange.id}
        pendingPolicyChange={pendingPolicyChange}
      />
    )
  );

  return (
    <div>
      {pendingPolicyChangesDetails}
      <PolicyExpandableDatagrid policyChanges={processedPolicyChanges} />
    </div>
  );
}

export default PolicyDatagridExpand;
